import { render, staticRenderFns } from "./DataChart.vue?vue&type=template&id=7898281a&scoped=true"
import script from "./DataChart.vue?vue&type=script&lang=js"
export * from "./DataChart.vue?vue&type=script&lang=js"
import style0 from "./DataChart.vue?vue&type=style&index=0&id=7898281a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7898281a",
  null
  
)

export default component.exports